global.window = {};

require("./colors.js");

module.exports = window.Colors;




//////////////////
// WEBPACK FOOTER
// ./node_modules/colors.js/index.js
// module id = 745
// module chunks = 0